import { useAppContext } from '../../state/AppContext'
import { ProductTileModel } from '../../utils/productTileCollection/productTileCollection'
import { ProductTile } from '../AutoGenerate/types/ProductTile'
import { ProductTileV2 } from '../ProductTileV2'

interface ProductGridLaneErrorProps {
  tile: ProductTileModel
  index: number
  productGridLayout?: 'horizontal' | 'vertical'
  hideProductDescription?: boolean
  colorSwatchCount: number
}

export const ProductGridLaneError = ({
  tile,
  index,
  productGridLayout,
  hideProductDescription,
  colorSwatchCount
}: ProductGridLaneErrorProps) => {
  const tileProps = tile.product?.template
  const rawQuantity = tileProps?.productsList?.selectedProductVariants?.Quantity
  return (
    <>
      <ProductTileV2
        name={tileProps?.tileDetails?.header?.value ?? ''}
        description={
          !hideProductDescription ? (tileProps?.tileDetails?.description?.value ?? '') : ''
        }
        image={tileProps?.tileDetails?.image?.cloudinaryImage?.[0]}
        linkUrl={tileProps?.tileDetails?.link?.href}
        callout={{ value: "Unavailable (Won't show in prod)", skin: 'holiday', variant: 'inverse' }}
        layout={productGridLayout || 'vertical'}
        disabled
        index={index + 1}
        pageZone=""
        mpvId={tile.mpvId}
        productId={tileProps?.productKey}
        showPrice={!!tile.showPrice}
        enableCampaignCallouts
        colorInformation={tile.colorInformation}
        colorSwatchCount={colorSwatchCount}
        selectedProductVariants={tileProps?.productsList?.selectedProductVariants}
        quantity={rawQuantity !== undefined ? Number(rawQuantity) : rawQuantity}
      />
    </>
  )
}

export const renderProductDebugError = (tile: ProductTileModel | ProductTile) => {
  const { debugMode } = useAppContext()
  return tile && !tile.associatedPageAvailable && debugMode
}
